import React from 'react'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import { FormattedMessage } from 'react-intl'
import { unitPrice } from '../../../../../../../utils/product'

export default props =>{
    useStyles(classes)
    const {value, onChange, installments} = props

    return <div className={classes.Installments}>
        {
            installments?.map(ins => <div className={`${classes.Ins} ${value === ins.number? classes.Selected:''}`} key={ins.number} onClick={e => onChange(ins.number)}>
                <span><span>{ins.number}x@</span> {(ins.rate * 100).toFixed(1)}%</span><br />
                <span>
                    <FormattedMessage id="price_per_installment" defaultMessage="{price}/month" values={{
                        price: unitPrice(ins.stagePrice)
                    }}/>
                </span>
            </div>)
        }
    </div>
}